import { lazy, Suspense, useEffect, useRef, useState } from 'react'
import { useAuth } from '../../auth/AuthContext'
import { useChatBubble } from '../chat/bubble'
import { IconoAsistente } from './IconoAsistente'
import './ayuda.css'

const Conversacion = lazy(() => import('../../pages/Ayuda').then((m) => ({ default: m.ConversacionAyuda })))

export function BurbujaAsistente() {
  const { user } = useAuth()
  // La conversación vive bajo la identidad; cambiar cuenta limpia también el panel.
  return <BurbujaCuenta key={user?.email} />
}
function BurbujaCuenta() {
  const [abierto, setAbierto] = useState(false)
  const [iniciado, setIniciado] = useState(false)
  const panel = useRef<HTMLElement>(null)
  const boton = useRef<HTMLButtonElement>(null)
  const chat = useChatBubble()
  useEffect(() => {
    if (abierto) { setIniciado(true); chat.close() }
  }, [abierto])
  useEffect(() => { if (chat.open) setAbierto(false) }, [chat.open])
  useEffect(() => {
    const comando = (e: Event) => {
      const modo = (e as CustomEvent).detail
      setAbierto((a) => modo === 'open' ? true : modo === 'close' ? false : !a)
    }
    const tecla = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && !e.altKey && e.key.toLowerCase() === 'k' && !e.repeat) { e.preventDefault(); e.stopPropagation(); setAbierto((a) => !a) }
      else if (e.key === 'Escape' && panel.current?.contains(e.target as Node)) { e.preventDefault(); e.stopPropagation(); setAbierto(false); boton.current?.focus() }
    }
    window.addEventListener('bee:asistente', comando)
    window.addEventListener('keydown', tecla, true)
    return () => { window.removeEventListener('bee:asistente', comando); window.removeEventListener('keydown', tecla, true) }
  }, [])
  useEffect(() => {
    if (abierto && iniciado) { const entrada = panel.current?.querySelector<HTMLTextAreaElement>('textarea'); if (entrada) entrada.focus(); else panel.current?.focus() }
  }, [abierto, iniciado])
  return <>
    <button ref={boton} className="asistente-burbuja" aria-label={abierto ? 'Cerrar asistente IA' : 'Abrir asistente IA'} aria-expanded={abierto} aria-controls="asistente-panel" aria-keyshortcuts="Meta+Shift+K Control+Shift+K" title="Asistente · Cmd/Ctrl + Shift + K" onClick={() => setAbierto((a) => !a)}><IconoAsistente /></button>
    {iniciado && <section ref={panel} hidden={!abierto} id="asistente-panel" className="asistente-panel" tabIndex={-1} role="dialog" aria-modal="false" aria-labelledby="asistente-titulo"><header className="asistente-barra"><h2 id="asistente-titulo">Asistente de bee camp</h2><button className="btn btn-quiet" aria-label="Cerrar conversación IA" onClick={() => { setAbierto(false); boton.current?.focus() }}>Cerrar <span aria-hidden="true">×</span></button></header><Suspense fallback={<p role="status">Cargando tu asistente…</p>}><Conversacion /></Suspense></section>}
  </>
}
